var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;stroke:#fff;}.b{opacity:0.116;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1389 -1318)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.021,2.253a4.122,4.122,0,0,0-1.114-.169c-.452,0-1.427.288-1.427.847V4.268H5.794V6.521H3.48v6.216H1.148V6.521H0V4.268H1.148V3.133C1.148,1.423,1.949,0,3.88,0A9.485,9.485,0,0,1,6.369.254Z",
    transform: "translate(1402.408 1327.42)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1389 1318)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 16.5,
    cy: 16.5,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 16.5,
    cy: 16.5,
    r: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.752669bcd89f88858e08594a025cf259.svg";
export { ForwardRef as ReactComponent };